/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:23
 * @LastEditTime : 2023-12-06 13:16:51
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\basicConfig\car.js
 */
/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-06-16 15:22:36
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/car/QueryPage'
export const batchUpdateOrDelete = '/icps/system/sign/basics/car/deletes'
export const updateSortNum = '/icps/system/sign/basics/car/update_sort_num'
export const saveOrUpdate = '/icps/system/sign/basics/car/saveOrUpdate'
export const Download = '/icps/system/sign/basics/car/exportList'
export function carMaintainsave(data) {
  return request({
    url: '/icps/system/sign/basics/carMaintain/save',
    method: 'post',
    data
  })
}
export function carMaintainQueryPage(data) {
  return request({
    url: '/icps/system/sign/basics/carMaintain/QueryPage',
    method: 'post',
    data
  })
}
export function QueryPlateNumber(data) {
  return request({
    url: '/icps/system/sign/basics/car/QueryPlateNumber',
    method: 'post',
    data
  })
}
/*类别维护*/
export function typeQuery() {
  return request({
    url: '/icps/system/sign/basics/carType/QueryCarTypes',
    method: 'post'
  })
}
export function isDeletetype(data) {
  return request({
    url: '/icps/system/sign/basics/carType/queryCarTypeByid',
    method: 'post',
    data
  })
}
export function typesaveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/basics/carType/saveOrUpdate',
    method: 'post',
    data
  })
}
export function queryCarNoData(data) {
  return request({
    url: '/icps/system/sign/basics/car/queryCarNoData',
    method: 'post',
    data
  })
}